import { useState } from "react";

import { ManageSubscriptionDialog } from "features/subscriptions/components";
import useSubscriptions from "features/subscriptions/hooks/useSubscriptions";

import ActivatePlanLayout from "../ActivatePlanLayout";
import SettingsScrollContent from "../SettingsScrollContent";
import PlanDetails from "./PlanDetails";

export default function AgencyPlan() {
  const [isManageOpen, setIsManageOpen] = useState(false);
  const { agency } = useSubscriptions();

  const showGetAgencyPlan =
    !agency || agency.subscription.status === "cancelled";

  return (
    <>
      {showGetAgencyPlan ? (
        <SettingsScrollContent>
          <ActivatePlanLayout
            plan="agency"
            onActivate={() => setIsManageOpen(true)}
          />
        </SettingsScrollContent>
      ) : (
        <PlanDetails onManageSubscription={() => setIsManageOpen(true)} />
      )}

      <ManageSubscriptionDialog
        initialState={agency || "agency"}
        isOpen={isManageOpen}
        setIsOpen={setIsManageOpen}
        mixpanelSource="billing_page"
      />
    </>
  );
}
